// extracted by mini-css-extract-plugin
module.exports = {"table":"WastageTable_table__2VkN3"};